import { Typography, Icon, Box, Tooltip } from 'shared/ui'
import { type IColumn } from 'shared/ui/TableNew'
import { type RowInbox } from 'entities/Inbox/model/Table/RowInbox'
import styles from './styles.module.scss'

export const getMemberInboxesColumns = (userId: number): IColumn<RowInbox>[] => [
  {
    field: 'fullName',
    name: 'Name',
    isSortable: false,
    width: '100%',
    renderRowCell: (row) => {
      const isOwner = row.owner?.id === userId

      const isSingleAirCallNumber = row.hasAircallNumber && row.numbersCount === 1

      const numbersInfoText = () => {
        if (row.numbersCount === 1) {
          return row.firstNumber?.formatted_number
        }
        return `${row.numbersCount} numbers`
      }

      return (
        <Box display='flex' alignItems='center' justifyContent='space-between' gap='4px'>
          <div className={styles.name}>
            <Typography
              variant='body-md-regular'
              ariaLabel='MemberFullName'
              tooltipProps={{
                label: row.name,
              }}
              ellipsis
            >
              {row.name}
            </Typography>
            <Box display='flex' alignItems='center' gap='4px'>
              <Typography
                variant='body-sm-regular'
                ariaLabel='MemberNumbers'
                color='var(--content-primary-tertiary)'
              >
                {numbersInfoText()}
              </Typography>
              {isSingleAirCallNumber && <Icon icon='aircall' />}
            </Box>
          </div>
          {isOwner && (
            <Tooltip
              label='This member is the only owner of this inbox and cannot be removed, as it would leave the inbox unmanaged.'
              placement='top'
              maxWidth={360}
            >
              <Icon icon='flagFilled' color='var(--content-attention-primary)' />
            </Tooltip>
          )}
        </Box>
      )
    },
  },
]
